var heading_default = {
  "fontElementMap": "IwwmR",
  "elementSpacing": "KJHej",
  "headerOne": "rjatq KJHej",
  "headerTwo": "CRND7 KJHej",
  "headerThree": "uB4gq KJHej",
  "headerFour": "_8XTeX KJHej",
  "headerFive": "OrZa7 KJHej",
  "headerSix": "ZEH8C KJHej",
  "child": "CDxx2"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
